module.exports = __webpack_public_path__ + "img/appDownload.e662dcb7.png";